/* eslint-disable */
import React, { useState, useCallback, useContext, createContext } from 'react';
import api from 'services';
import { useNewToast } from 'hooks/newToast';
import { appWarnings } from 'utils/appWarnings';

const success = {
  type: 'success',
  autoClose: 3000,
};

const RegAtividadesTimelineContext = createContext({});

export const RegAtividadesTimelineProvider = ({ children }) => {
  const { showToast } = useNewToast();

  const [timelineData, setTimelineData] = useState([]);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [timelineError, setTimelineError] = useState(null);

  const getTimelineData = useCallback(
    async (safraId) => {
      if (!safraId) {
        setTimelineData([]);
        return;
      }

      try {
        setTimelineLoading(true);
        setTimelineError(null);

        const response = await api
          .regAtividade()
          .getRegAtividadesTimeline(safraId);

        const transformedData = response.data.map((item) => ({
          id: item.id,
          name: item.name,
          periods: item.periods.map((period) => ({
            id: period.id,
            start: new Date(period.start + 'T00:00:00'),
            end: new Date(period.end + 'T23:59:59'),
          })),
        }));

        setTimelineData(transformedData);
      } catch (error) {
        setTimelineError(error);
        showToast(appWarnings.Danger(error));
      } finally {
        setTimelineLoading(false);
      }
    },
    [showToast],
  );

  const value = {
    timelineData,
    timelineLoading,
    timelineError,
    getTimelineData,
  };

  return (
    <RegAtividadesTimelineContext.Provider value={value}>
      {children}
    </RegAtividadesTimelineContext.Provider>
  );
};

export function useRegAtividadesTimeline() {
  const context = useContext(RegAtividadesTimelineContext);
  if (!context) {
    throw new Error(
      'useRegAtividadesTimeline must be used within a RegAtividadesTimelineProvider',
    );
  }
  return context;
}
